/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useEffect } from "react";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";
import { number, object, shape, any } from "prop-types";

import TaboolaScript from "../../ads/taboola-ad/load-taboola-ad";
// import VukkleScript from "../../ads/vuukle-script";
import { triggerVuukleScript } from "../../utils";
import { loadStoriesForInfiniteScroll } from "../../helper/api";

import Bredcrum from "../../story-templates/story-header/bredcrums";
import TextStory from "../../story-templates/text";
import VideoStory from "../../story-templates/video";
import PodCastStory from "../../story-templates/podcast";
import PhotoStory from "../../story-templates/photo";
import ListcleStory from "../../story-templates/listcle";
import LiveBlogStory from "../../story-templates/live-blog";
import ExclusiveStory from "../../story-templates/exclusive";
import CartoonStory from "../../story-templates/cartoon";
import PanchangaStory from "../../story-templates/panchanga";
import HoroscopeStory from "../../story-templates/horoscope";
// import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

import "./story.m.css";
import SocialMediaShare from "../../molecules/social-media-share";

const pickTemplate = {
  text: TextStory,
  video: VideoStory,
  photo: PhotoStory,
  podcast: PodCastStory,
  cartoon: CartoonStory,
  listicle: ListcleStory,
  panchanga: PanchangaStory,
  horoscope: HoroscopeStory,
  "live-blog": LiveBlogStory,
  "fact-check": TextStory,
  "pv-exclusive": ExclusiveStory,
  "movie-review": TextStory,
  "gadget-review": TextStory,
  "sponsored-story": TextStory,
};
function StoryPageBase({ index, story, initialPath }) {
  const Component = pickTemplate[story["story-template"]] || TextStory;

  useEffect(() => {
    setTimeout(() => {
      triggerVuukleScript(story);
    }, [5000]);
  }, []);

  return (
    <div styleName="story-wrapper" className="container">
      {index === 0 && <Bredcrum initialPath={initialPath} story={story} type="story-page" />}
      <Component story={story} index={index} />
      <div styleName="sharing-options">
        <SocialMediaShare story={story} />
      </div>
    </div>
  );
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  otherProp: any,
};
export function StoryPage(props) {
  const preventCopyHandler = (event) => event.preventDefault();
  const template = props?.data?.story["story-template"] ? props.data.story["story-template"] : "text";

  return (
    <div onCopy={preventCopyHandler}>
      {/* {template === "sponsored" || template === "live-blog" ? null : <VukkleScript />} */}
      <TaboolaScript type="article" />
      <InfiniteStoryBase
        {...props}
        render={(storyProps) => <StoryPageBase {...storyProps} initialPath={props.currentPath} />}
        loadItems={() => loadStoriesForInfiniteScroll(props.data.story)}
        onInitialItemFocus={(item) =>
          app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
        }
        onItemFocus={(item) => console.log(`Story In View: ${item.story.headline}`)}
      />
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object,
  }),
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);
